import { createConfig, http } from "wagmi";
import { mainnet, sepolia } from "wagmi/chains";
import { injected, walletConnect } from "wagmi/connectors";

const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID) || 11155111;
const RPC_URL =
  process.env.REACT_APP_NODE_1 ||
  "https://eth-sepolia.g.alchemy.com/v2/n_4iaIl35yi2Vc0AV3-eg9rsdbG95Tfg";

const WC_PROJECT_ID = "56e76179389975627afbbb8fdb7d6712";

const chain = CHAIN_ID === 1 ? mainnet : sepolia;

export const wagmiConfig = createConfig({
  chains: [chain],
  connectors: [
    injected(),
    walletConnect({ projectId: WC_PROJECT_ID }),
  ],
  transports: {
    [chain.id]: http(RPC_URL),
  },
});
